/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ResourceUtilizationOverview {
    getFixupPrototypeFunction() { return ResourceUtilizationOverview.fixupPrototype; }

    static newInstance(model: Partial<ResourceUtilizationOverview>): ResourceUtilizationOverview {
        let obj = Object.assign(new ResourceUtilizationOverview(), model);
        ResourceUtilizationOverview.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ResourceUtilizationOverview>): ResourceUtilizationOverview {
        if (!model) return null;
        return ResourceUtilizationOverview.newInstance(<ResourceUtilizationOverview> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ResourceUtilizationOverview) {
        if (!obj) return;

        models.ResourceUtilizationOverview.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ResourceUtilizationOverview): boolean {
        Object.setPrototypeOf(obj, ResourceUtilizationOverview.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.from_time === undefined) {
            this.from_time = 0;
        }
        if (this.to_time === undefined) {
            this.to_time = 0;
        }
    }

    /**
     * Utilization Start Hour Of Day (0-23)
     */
    from_time: number;

    /**
     * Utilization End Hour Of Day (0-23)
     */
    to_time: number;

    day: models.DayOfWeek;

    /**
     * Schedule Recommendation Utilization
     */
    utilization: models.ScheduleRecommendationUtilization;

}
